import React, { useState, useMemo } from 'react'

import Gap from '@/common/components/Gap'
import SelectField from '@/common/components/SelectField'
import { GOOGLE_MAP_NEARBY_TYPES } from '@/common/constants'
import { HoveredItemProvider } from '@/common/hooks/useHoveredItem'
import { NEARBY_TYPES_PLACEHOLDER } from '@/modules/property/pages/PlaceDetailPage/translation'

import NearbyPlaceDetailList from '../NearbyPlaceDetailList'
import NearbyPlacesMap from '../NearbyPlacesMap'
import { DetailWrapper } from './styled'

interface NearbyPlacesProps {
  place: RentAPerfect.Condo
}

const NearbyPlaces = ({ place }: NearbyPlacesProps) => {
  const nearbyPlaces = useMemo(() => place.NearbyPlace ?? [], [place])
  const nearbyTypeOptions = useMemo(
    () =>
      GOOGLE_MAP_NEARBY_TYPES.filter(({ value }) =>
        nearbyPlaces.find(({ type }) => type === value)
      ),
    [nearbyPlaces]
  )

  const [types, setTypes] = useState<string[]>(
    nearbyTypeOptions.map(({ value }) => value)
  )

  const filteredNearbyPlaces = useMemo(
    () => nearbyPlaces.filter(({ type }) => types.includes(type)),
    [nearbyPlaces, types]
  )

  return (
    <HoveredItemProvider>
      <Gap space={24}>
        <NearbyPlacesMap place={place} nearbyPlaces={filteredNearbyPlaces} />
        {nearbyPlaces.length ? (
          <DetailWrapper>
            <SelectField
              placeholder={NEARBY_TYPES_PLACEHOLDER}
              options={nearbyTypeOptions}
              value={types}
              onChange={setTypes as (value: string[]) => void}
              multiple
            />
            <NearbyPlaceDetailList nearbyPlaces={filteredNearbyPlaces} />
          </DetailWrapper>
        ) : null}
      </Gap>
    </HoveredItemProvider>
  )
}

export default NearbyPlaces
